import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import "./Navbar.css";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import Logos from "../myimgs/nivora 1.png";

function CustomNavbar() {
  const [userName, setUserName] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation(); // Detect current route

  useEffect(() => {
    const storedName = localStorage.getItem("userName");
    if (storedName) {
      setUserName(storedName);
    }
  }, []);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 1);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem("userName");
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    window.location.href = "/";
  };

  // Live search debounce (optional)
  useEffect(() => {
    if (searchTerm.trim() !== "") {
      const delayDebounce = setTimeout(() => {
        console.log("Searching for:", searchTerm);
      }, 500);
      return () => clearTimeout(delayDebounce);
    }
  }, [searchTerm]);

  return (
    <Navbar expand="lg" className={`${scrolled ? "scrollnav" : ""}`}>
      <Container fluid className="headres">
        {/* Logo */}
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src={Logos}
            alt="Twoffers Logo"
            width="40"
            height="40"
            className="logos"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          {/* Menu */}
          <Nav className="mx-auto text-uppercase fw-semibold">
             <Nav.Link
              onClick={() => (window.location.href = "/")}
              className={location.pathname === "/" ? "active-menu" : ""}
            >
              Home
            </Nav.Link>
            <Nav.Link
              onClick={() => (window.location.href = "/buyer")}
              className={location.pathname === "/buyer" ? "active-menu" : ""}
            >
              Buy
            </Nav.Link>
            <Nav.Link
              onClick={() => (window.location.href = "/profile")}
              className={location.pathname === "/profile" ? "active-menu" : ""}
            >
              Sell
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contactus"
              className={
                location.pathname === "/contactus" ? "active-menu" : ""
              }
            >
              Contact Us
            </Nav.Link>
          </Nav>

          {userName ? (
            <NavDropdown
              title={userName}
              id="user-dropdown"
              align="end"
              className="fw-bold"
            >
              <NavDropdown.Item as={Link} to="/profile">
                My Profile
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/profile">
                My Offers
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/profile">
                Favourites
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
            </NavDropdown>
          ) : (
            <Link to="/login" className="btn login-btn px-4 fw-bold">
              Register/Login
            </Link>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default CustomNavbar;
